import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ForbiddenPage() {
  const { t } = useTranslation();
  return (
    <div style={shell}>
      <div style={card}>
        <h1 style={{ margin: 0, color: "var(--err)", fontSize: 28 }}>{t("forbidden.code", "403")}</h1>
        <p style={{ margin: 0, fontSize: 18, color: "var(--ink-2)" }}>{t("forbidden.title", "Pristup odbijen")}</p>
        <p style={{ margin: 0, color: "var(--ink-3)", fontSize: 14 }}>
          {t("forbidden.message", "Nemate dozvolu da pregledate ovu stranicu.")}
        </p>
        <Link to="/" style={{ color: "var(--brand-primary)", fontSize: 14 }}>
          {t("forbidden.back", "Nazad na početnu")}
        </Link>
      </div>
    </div>
  );
}

const shell: React.CSSProperties = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "var(--bg)",
};
const card: React.CSSProperties = {
  background: "var(--surface)",
  padding: 32,
  borderRadius: 12,
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  gap: 12,
  boxShadow: "0 1px 3px rgba(0,0,0,.08)",
};
